import { FaIcon } from '@components/FaIcon';
import { IconButton, IconButtonProps } from '@material-ui/core';
import React from 'react';

export type CsvButtonProps = IconButtonProps & {

}

export function CsvButton ({children, ...props}: CsvButtonProps) {
    return (
        <IconButton color="primary" {...props}>
            <FaIcon icon="fa-solid fa-file-csv" />
        </IconButton>
    );
}